export const RequiredLabel = () => {
  return <span className="color-red">*</span>;
};
